/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*
* If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
* "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*/

function adjustVideoSize() {
  const videos = document.querySelectorAll('video[data-cloudinary-src]');
  videos.forEach(video => {
    const cloudinarySrc = video.getAttribute('data-cloudinary-src');
    const step = parseInt(video.getAttribute('data-cloudinary-step')) || 400;
    const containerWidth = video.parentElement.offsetWidth;
    const roundedWidth = Math.ceil(containerWidth / step) * step;
    const newSrc = cloudinarySrc.replace('video/upload/', `video/upload/w_${roundedWidth}/`);
    console.log('cloudinary video');
    if (video.src !== newSrc) {
      video.src = newSrc;
    }
  });
}

// Initial adjustment
$(document).ready(function(){
  //adjustVideoSize();
});

// Re-adjust iframe size when the window is resized
window.onresize = adjustVideoSize;

$(document).ready(function(){
const desktop_slider = document.querySelector('.desktop_only.Product__Slideshow');  
if (desktop_slider) {
flickity = new Flickity(desktop_slider, {
autoPlay: false,
prevNextButtons: true,
pageDots: false,
draggable: true,
wrapAround: true,
selectedAttraction: 0.015,
friction: 0.25,
arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
});
}
});

(function() {
  const stickyContainer = document.getElementById('sticky-container');
  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1
  });
  
  document.querySelectorAll('.ProductForm__AddToCart').forEach(target => {
    observer.observe(target);
  })
  
  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stickyContainer.classList.add('u-hidden');
      }
      else {
        stickyContainer.classList.remove('u-hidden');
      }
    })
  }
})();


//
//   Variables
//
//////////////////////////////////////////////////////////////////////

// Play with this value to change the speed
let tickerSpeed = 0.6;

let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.ProductList--carousel');


//
//   Functions
//
//////////////////////////////////////////////////////////////////////

const update = () => {
if (isPaused) return;
if (flickity.slides) {
flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
flickity.selectedIndex = flickity.dragEndRestingSelect();
flickity.updateSelectedSlide();
flickity.settle(flickity.x);
}
window.requestAnimationFrame(update);
};

const pause = () => {
isPaused = true;
};

const play = () => {
if (isPaused) {
isPaused = false;
window.requestAnimationFrame(update);
}
};


//
//   Create Flickity
//
//////////////////////////////////////////////////////////////////////

if (slideshowEl) {

flickity = new Flickity(slideshowEl, {
autoPlay: false,
prevNextButtons: true,
pageDots: false,
draggable: true,
wrapAround: true,
selectedAttraction: 0.015,
friction: 0.25,
arrowShape: 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z'
});
flickity.x = 0;


//
//   Add Event Listeners
//
//////////////////////////////////////////////////////////////////////

slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);

flickity.on('dragStart', () => {
isPaused = true;
});


//
//   Start Ticker
//
//////////////////////////////////////////////////////////////////////

update();

}

if($(window).width() < 992){
$(document).ready(function(){
    $('.table-section .right-content').slick({
        infinite: false,
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        dots: true
    });
});
}

$(document).on("click", ".slick-arrow", function(e) {
  console.log('hi');
    e.stopPropagation();
    e.preventDefault();
});

$(document).on("click", ".product_link", function(event) {
        // Prevent default redirection behavior of the anchor tag
        event.preventDefault();

        // Check if the click occurred on the specified elements
        if ($(event.target).is('.slick-arrow, .product-option-plus-button, .size_block')) {
            // Click occurred on specified elements, do nothing
            return;
        } else {
            // Click occurred outside of specified elements, redirect to href
            var href = $(this).attr('href');
            if (href) {
                window.location.href = href; // Redirect to the href of the anchor tag
            }
        }
    });